import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAd, postAdClick } from "../../api/mainApi";
import { useTelegram } from "../../context/TelegramContext";

const Advertisement = () => {
  const { t, i18n } = useTranslation();
  const tg = useTelegram();
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAd = async () => {
      try {
        setLoading(true);
        // Використовуємо функцію getAd з основного API, передаючи параметри
        const data = await getAd(tg.initData);
        setAd(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAd();
  }, [i18n.language]);

  const handleLinkClick = async (e) => {
    e.preventDefault();
    if (!ad?.id) return; // перевірка наявності id реклами

    try {
      // Відправка даних для підрахунку переходів через postAdClick
      await postAdClick({
        ad_id: ad.id,
        user_id: tg.initDataUnsafe?.user?.id,
        language: i18n.language,
      });
    } catch (err) {
      console.error("Помилка відправки трекінгу:", err);
    } finally {
      // Перенаправлення на цільову URL після відправки запиту
      window.location.href = ad.linkUrl;
    }
  };

  if (loading) {
    // Skeleton preloader
    return (
      <div className="w-full animate-pulse p-4 border rounded-lg bg-gray-950">
        <div className="h-6 bg-gray-300 rounded w-1/2 mb-4"></div>
        <div className="h-4 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 bg-gray-300 rounded w-2/3"></div>
      </div>
    );
  }

  if (!ad) return null;

  const { title, description, text, backgroundImage, linkUrl, linkText } = ad;
  // Використовуємо стандартний текст, якщо linkText відсутній
  const defaultLinkText = t("defaultLinkText", "Learn more");

  return (
    <div
      onClick={handleLinkClick}
      className="w-full px-4 py-2 rounded-lg shadow-md bg-cover bg-center text-white text-start bg-gray-950"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-2xl font-bold">{title}</h2>
        <span className="text-sm bg-black/50 px-2 py-1 rounded-full">Ad</span>
      </div>

      <p className="mb-4">{description}</p>
      {text && <p className="mb-2">{text}</p>}

      <a
        href={linkUrl}
        onClick={handleLinkClick}
        className="text-lg float-end text-end inline-block underline text-white font-bold rounded hover:opacity-80 transition"
      >
        {linkText || defaultLinkText} →
      </a>
    </div>
  );
};

export default Advertisement;
